import {SeasonPassRenewalCartItemPayload} from "./Types";
import Axios from "axios";
import {getLogger} from "../../Services/LoggingService";
export class CartService {

    async validateSeasonPassRenewal(vendor: string, payload: SeasonPassRenewalCartItemPayload[]):Promise<boolean> {
        if (!payload || payload.length === 0) {
            throw new Error("Season pass renewal payload cannot be empty");
        }
        let url = `${import.meta.env.VITE_BK_CHECKOUT_BASE_URL}/cart/validateCart`;
        const params = new URLSearchParams();
        params.append('ident', vendor);
        params.append('c', JSON.stringify(payload));
        url += `?${params.toString()}`;
        try {
            const {data} = await Axios.get(url,{headers: {'Content-Type': 'application/json'}});
            if(data?.success === true )
            {
                return true;
            }
            return false;
        } catch (e: unknown) {
         if (Axios.isCancel(e)){
             // Do nothing
         }  else {
             getLogger().error(new Error("Season pass renewal validation failed"));
         }
        }
        return false;
    }

    getCheckoutUrl(vendor: string, payload: SeasonPassRenewalCartItemPayload[]):string {
        if (!payload || payload.length === 0) {
            throw new Error("Season pass renewal payload cannot be empty");
        }
        let url = `${import.meta.env.VITE_BK_CHECKOUT_BASE_URL}/cart/set`;
        const params = new URLSearchParams();
        params.append('ident', vendor);
        params.append('c', JSON.stringify(payload));
        url += `?${params.toString()}`;
        return url;
    }
}

